import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getOrder } from '../../store/orders_provider/actions';

import {
    Row,
    Col,
    Card,
    CardBody,
    Spinner
} from 'reactstrap';

import PageBase from 'components/Common/PageBase';
import OrderHeader from './OrderHeader';
import OrderSummary from './OrderSummary';
import PageNotFound from 'pages/Utility/PageNotFound';

import 'flatpickr/dist/themes/material_red.css';


const breadcrumbList = [
    { id: '1', title: 'Pedidos a Proveedor', link:'/distributor/orders-provider', active: false },
    { id: '2', title: 'Detalle de pedidos', link: '#', active: true }
];

export default function OrderProviderContainer() {   
    const dispatch    = useDispatch();
    const { orderId } = useParams(); 

    const { dailys, ui } = useSelector(state => state.OrdersProvider);

    const { isLoading, isError } = ui;

    // El reducer asigna la respuesta sin comprobarla: si no llegara un arreglo,
    // `.length` seria undefined y la pantalla volveria a quedarse en blanco.
    const items = Array.isArray(dailys) ? dailys : [];

    useEffect(() => {
        dispatch(
            getOrder(orderId)
        );
    }, []);

    if(isError) return <PageNotFound />

    return (
        <>  
            <PageBase
                titleMeta="Detalle del pedido"
                titleBread="Detalle de Pedidos a Proveedor"
                itemsBread={ breadcrumbList }
            >
                {
                    isLoading ? <Spinner /> : null
                }          
                { !isLoading && items.length === 0 && (
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody className="text-center text-muted">
                                    Este pedido no tiene partidas autorizadas.
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
                { !isLoading && items.length > 0 && (
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>
                                    <OrderHeader
                                        id={ items[0].id }
                                        provider={ items[0].provider }
                                        date={ items[0].date }
                                    />
                                    <OrderSummary
                                        dailys={ items }
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
            </PageBase>
        </>
    )
}